import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const advantages = [{
  name: 'More accurate',
  tone: INK.blue,
  summary: 'Deterministic workflows + specialized intelligence',
  items: ['Deterministic workflows', 'Closed-loop functions & structured scripts', 'Specialized models', 'Curated industry data', 'Templates & industry-native assets', 'Validation & scoring systems'],
  phrase: 'Repeatable, structured outputs.'
}, {
  name: 'More private',
  tone: INK.violet,
  summary: 'Controlled proprietary data + institutional infrastructure',
  items: ['Controlled proprietary data', 'Secure enterprise workflows', 'Permissioned information access', 'Data separation between organisations', 'Private firm intelligence', 'Domestic deployment where relevant'],
  phrase: 'Institutional intelligence — not public model training data.'
}, {
  name: 'More cost-efficient',
  tone: INK.emerald,
  summary: 'Smaller specialized models + intelligent model routing',
  items: ['Classification & tagging', 'Data & entity extraction', 'Document categorization', 'Normalization', 'Basic scoring & repeatable calculations', 'Frontier models reserved for reasoning'],
  phrase: 'Frontier intelligence only where reasoning matters.'
}];
export function AdvantagesSlide() {
  return <Slide data-id="element-132" data-mp="2kvipkztdtkqd">
      <Eyebrow data-id="element-133" data-mp="2kv8zlc8c7dko">Three technical advantages</Eyebrow>
      <Title className="mt-[2.2cqh]" data-id="element-134" data-mp="2kxvfq09an1ei">More accurate. More private. More cost-efficient.</Title>

      <div className="mt-auto grid grid-cols-3 gap-[1.6cqw]" data-id="element-135" data-mp="2fz0p4c5348ju">
        {advantages.map((a, i) => <Reveal key={a.name} delay={0.06 * i} className="flex flex-col border border-white/10 bg-white/[0.025] px-[1.6cqw] pb-[2.4cqh] pt-[2.8cqh]" data-id="element-136" data-mp="j2kz3an2v48l" data-mpi={i}>
            <span className="block h-[2px] w-[3cqw]" style={{
          background: a.tone
        }} data-id="element-137" data-mp="x83946fma77i" />
            <p className="mt-[2cqh] text-[2.3cqw] leading-none" style={{
          ...SERIF,
          color: a.tone
        }} data-id="element-138" data-mp="1227g2povuf8l">
              {a.name}
            </p>
            <p className="mt-[1.4cqh] text-[1cqw] leading-snug text-[#C3CBD9]" data-id="element-139" data-mp="t8chy1m6hp2g">{a.summary}</p>
            <ul className="mt-[2.4cqh]" data-id="element-140" data-mp="1gygandxtw4eo">
              {a.items.map(item => <li key={item} className="border-b border-white/8 py-[1.05cqh] text-[0.98cqw] text-[#E3E8F1]" data-id="element-141" data-mp="1gwcan731vpjo">
                  {item}
                </li>)}
            </ul>
            <p className="mt-[2.4cqh] text-[1.15cqw] leading-snug text-[#F4F7FC]" style={SERIF} data-id="element-142" data-mp="1723hqia3xukz">
              {a.phrase}
            </p>
          </Reveal>)}
      </div>

      <div className="mt-[2cqh]" data-id="element-143" data-mp="3ron89ia0aij0">
        <Label data-id="element-144" data-mp="jx77ra2xswx">
          Privacy controls describe platform design; deployment specifics are agreed per enterprise customer.
        </Label>
      </div>
    </Slide>;
}